export const SDK_VERSION = '7.16.0';
